<script>
import Layout from "@layouts/main-fluid";
import api from "@services/api";
import tabela from "@components/Table.vue";
import dataFechamento from "@forms/DataFechamentoForm.vue"
export default {
  page: {
    title: "Data Fechamento"
  },
  components: {
    Layout,
    tabela,
    dataFechamento
  },
  data: () => ({
    title: "Data fechamento",
    items: [
      {
        text: "Data Fechamento",
        href: "/DataFechamento",
        active: true
      }
    ],
    fields: [
      { name: "dataFechamento", description: "Data do Fechamento", type: "date" },
      { name: "dataCadastro", description: "Data de Criação", type: "date" },
      { name: "email", description: "Usuário" }
    ],
    dataFechamentoList: null
    
  }),
  created() {
    this.getDataFechamentoList();
  },
  watch: {
   
  },
  computed: {
    filters() {
      return this.$store.state.filter.filters;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    getDataFechamentoList() {
      api
        .get(`crud/Expediente/DataFechamento`)
        .then(response => (this.dataFechamentoList = response.data["data"]));
    }
  }
};
</script>

<template>
  <Layout :title="title" :items="items">    
    <div class="page-content">
      <div> 
        <dataFechamento @RecarregarTable="getDataFechamentoList"></dataFechamento>
      </div>
      <div> 
        <tabela :fields="this.fields" :lista="this.dataFechamentoList" ></tabela>
      </div>
    </div>
  </Layout>
</template>
